<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="7">
      <v-card class="pa-5 mb-4" outlined>
        <v-card-title>
          <h1>About Our Shop</h1>
        </v-card-title>
        <v-card-text>
          <AirtableHtml setting-name="About Page" />
        </v-card-text>
      </v-card>
      <v-row justify="center" class="my-4">
        <v-btn exact depressed dark x-large color="blue" to="/menu"
          >View the Menu</v-btn
        >
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import AirtableHtml from '@/components/AirtableHtml'

export default {
  name: 'AboutView',
  components: { AirtableHtml },
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.markdown-body {
  color: rgb(30, 30, 30);
  font-size: 1.2rem;
  font-weight: normal;
  font-family: $body-font-family;
}
</style>
